import React from 'react';

const visibilityHidden = {visibility: 'hidden'};

const ProfileStats = ({data, type, userType}) => (
  <div className="profile-stats">
    {
      data.map((item, index) => {
        if (index === 1 && type === 'channel' ) {
          return (
            <div className="profile-stat" key={item.title}>
              {userType ? (
                <React.Fragment>
                  <span className="stat-name">{item.title}</span>
                  <span className="stat-value">{item.numbers}</span>
                </React.Fragment>
              ) : <span style={visibilityHidden}>Hidden</span>}
            </div>
          )
        }

        if (index === 1) {
          return (
            <div className="profile-stat" key={item.title}>
              <React.Fragment>
                <span className="stat-name">{item.title}</span>
                <span className="stat-value">{item.numbers}</span>
              </React.Fragment>
            </div>
          )
        }

        return (
          <div className="profile-stat" key={item.title}>
            <span className="stat-name">{item.title}</span>
            <span className="stat-value">{item.numbers}</span>
          </div>
        )
      })
    }
  </div>
)

export default ProfileStats;


// WEBPACK FOOTER //
// ./src/components/Modules/ProfileStats/index.js